import request from '../services/request';
import { PATH } from './path';
export const BASE_INFO = {
  dbType: [
    {
      title: '对象存储(KS3)',
      subTitle:
        '金山云对象存储服务（Kingsoft Standard Storage Service，简称KS3），是金山云为开发者提供无限制、多备份、分布式的低成本存储空间解决方案。',
      link: 'https://docs.ksyun.com/documents/855',
      icon: 'icon icon-kpc-ks3',
      cover: 'img',
      type: 'ks3',
      action: 'createKS3Db'
    },
    {
      title: '关系型数据库(KRDS)',

      subTitle:
        '金山云关系型数据库服务(Kingsoft Relational Database Service，简称KRDS)是一种即开即用、稳定可靠、可弹性伸缩的关系型云数据库服务。',
      link: 'https://docs.ksyun.com/documents/6012',
      icon: 'icon icon-kpc-krds',
      cover: 'img',
      type: 'rds',
      action: 'createRDSDB'
    },
    {
      title: 'MongoDB',
      icon: 'icon icon-kpc-mongodb',
      subTitle:
        '金山云数据库MongoDB是金山云为企业和开发者提供100%兼容MongoDB协议的文档型NoSQL数据库服务。',
      link: 'https://docs.ksyun.com/documents/658',
      cover: 'img'
    },
    {
      title: '云数据库Redis',
      icon: 'icon icon-kpc-redis',
      subTitle:
        '云数据库Redis是金山云推出的即开即用、稳定可靠的在线缓存和键值存储服务。支持主从热备，提供自动容灾切换、实例监控、在线扩容等数据库服务。',
      link: 'https://docs.ksyun.com/documents/1008',
      cover: 'img'
    }
  ]
};
export const API = {
  // 查询hive\mysql数据库列表
  dblist: '/query/database'
};
/**
 * 创建hive数据表
 */
export const requestCreateHiveTable = async data => {
  return request({
    url: PATH.metaDataManage.hiveTableCreate,
    method: 'POST',
    data
  });
};

export const requestUpdateHiveTable = async data => {
  return request({
    url: PATH.metaDataManage.hiveTableUpdate,
    method: 'POST',
    data
  });
};
export const requestQueryTable = async params => {
  return request({
    url: PATH.metaDataManage.queryTable,
    method: 'get',
    params
  });
};

export const requestDelTable = async data => {
  return request({
    url: PATH.metaDataManage.delTable,
    method: 'post',
    data
  });
};
export const requestRDSInstance = async data => {
  return request({
    url: PATH.metaDataManage.RDSInstance,
    method: 'POST',
    data
  });
};
export const requestCheckDB = async params => {
  return request({
    url: PATH.metaDataManage.checkDB,
    method: 'get',
    params
  });
};
/**
 * 创建ks3数据库
 */
export const requestCreateKs3 = async data => {
  return request({
    url: PATH.metaDataManage.hiveCreate,
    method: 'POST',
    data
  });
};
/**
 * 创建rds数据库
 */
export const requestRDS = async data => {
  return request({
    url: PATH.metaDataManage.rdsCreate,
    method: 'POST',
    data
  });
};
// 删除数据库
export const requestDbDrop = async data => {
  return request({
    url: PATH.metaDataManage.dbDrop,
    method: 'POST',
    data
  });
};

/**
 * 获取数据库列表
 */
export const requestDBList = async params => {
  return request({
    url: PATH.metaDataManage.dbList,
    params
  });
};
/**
 * 获取数据库表
 */
export const requestDBTableList = async params => {
  return request({
    url: PATH.metaDataManage.dbTables,
    params
  });
};
/**
 * 改变授权
 */
export const requestChangeRDSAuth = async params => {
  return request({
    url: PATH.metaDataManage.changeRDSAuth,
    params,
    method: 'post'
  });
};
/**
 * 获取RDS实例下的数据库
 */
export const requestInstanceDBList = async params => {
  return request({
    url: PATH.metaDataManage.instanceDBList,
    params,
    method: 'get'
  });
};
/**
 * 自动填充
 */
export const requestShowSchema = async params => {
  return request({
    url: PATH.metaDataManage.showSchema,
    params,
    method: 'get'
  });
};
/**
 * 校验location
 */
export const requestCheckLocation = async params => {
  return request({
    url: PATH.metaDataManage.checkLocation,
    params,
    method: 'get'
  });
};

export const requestBucketList = async params => {
  return request({
    url: PATH.metaDataManage.getBucketList,
    params,
    method: 'get'
  });
};

export const requestBucketPathList = async params => {
  return request({
    url: PATH.metaDataManage.getBucketPathList,
    params,
    method: 'get'
  });
};
